import { usePostMutation } from "@/api/swr/useMutation";  
import { z } from "zod";  

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];  

export const useApplyCertificate = (id: number, config?: Config) => {  
  // The ID is now passed as a direct parameter  
  return usePostMutation(  
    z.undefined(),  
    z.null(),  
    `/console/certifications/${id}/apply`,  
    config  
  );  
};
